import { render, staticRenderFns } from "./generalInformation.vue?vue&type=template&id=32b67374&scoped=true"
import script from "./generalInformation.vue?vue&type=script&lang=js"
export * from "./generalInformation.vue?vue&type=script&lang=js"
import style0 from "./generalInformation.vue?vue&type=style&index=0&id=32b67374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b67374",
  null
  
)

export default component.exports